import React, { useState, useRef, useEffect } from "react";
import info from "@images/info.svg";

const Popover = ({ content, redirect }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="popover-wrapper" ref={ref}>
      <img
        src={info}
        alt="info"
        className="details-info-icon"
        onClick={() => setOpen(!open)}
        style={{ cursor: "pointer" }}
      />
      {open && (
        <div className="popover-content">
          {redirect && <div className="redirect-title">Перенаправление:</div>}

          {content.split("<br>").map((text, index) => (
            <React.Fragment key={index}>
              <div className="popover-text">
                {text}
                {index < content.split("<br>").length - 1 && <br />}
              </div>
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
};

export default Popover;
